document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".banner-product-carousel-section .js_carousel").forEach(function (slider) {

    if (typeof jQuery === "undefined" || typeof jQuery.fn.slick === "undefined") {
      console.warn("Slick or jQuery not loaded");
      return;
    }

    if (jQuery(slider).hasClass("slick-initialized")) return;

    const arrowsContainer = slider.getAttribute("data-append-arrows");

    jQuery(slider).slick({
      arrows: true,
      dots: false,
      infinite: true,
      appendArrows: arrowsContainer,

      /* DESKTOP */
      slidesToShow: 3,
      slidesToScroll: 2,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

  });

});
